import { c as _c } from "react/compiler-runtime";
import LiveBadge from '@pc/components/badge/LiveBadge';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
const HOVER_BRIDGE_WIDTH = 6;
const POPUP_WIDTH = 211;
interface BJListItemProps {
  isLive?: boolean;
  isRT?: boolean; // RT 대응 - 전환 후 삭제 예정
  onClick: () => void;
  title?: string;
  userImg: string;
  userNick: string;
}
function BJListItem(t0) {
  const $ = _c(27);
  const {
    isLive: t1,
    isRT: t2,
    onClick,
    title: t3,
    userImg,
    userNick
  } = t0;
  const isLive = t1 === undefined ? false : t1;
  const isRT = t2 === undefined ? false : t2;
  const title = t3 === undefined ? "" : t3;
  const [coords, setCoords] = useState(null);
  const itemRef = useRef(null);
  const popupAreaRef = useRef(null);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = relatedTarget => {
      if (!(relatedTarget instanceof Node)) {
        return false;
      }
      return itemRef.current?.contains(relatedTarget) === true || popupAreaRef.current?.contains(relatedTarget) === true;
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const isMovingInsideSharedHoverArea = t4;
  let t5;
  let t6;
  if ($[1] !== coords) {
    t5 = () => {
      if (!coords) {
        return;
      }
      const handleScroll = () => {
        setCoords(null);
      };
      window.addEventListener("scroll", handleScroll, true);
      return () => {
        window.removeEventListener("scroll", handleScroll, true);
      };
    };
    t6 = [coords];
    $[1] = coords;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  useEffect(t5, t6);
  let t7;
  if ($[4] !== onClick) {
    t7 = () => {
      onClick();
    };
    $[4] = onClick;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = event => {
      const rect = event.currentTarget.getBoundingClientRect();
      setCoords({
        top: rect.top - 4,
        left: rect.right - 2
      });
    };
    t9 = event_0 => {
      if (isMovingInsideSharedHoverArea(event_0.relatedTarget)) {
        return;
      }
      setCoords(null);
    };
    $[6] = t8;
    $[7] = t9;
  } else {
    t8 = $[6];
    t9 = $[7];
  }
  let t10;
  if ($[8] !== userImg) {
    t10 = <div className="h-6 w-6 shrink-0 overflow-hidden rounded-full border border-transparent "><img width={24} height={24} src={userImg} className="min-h-6 min-w-6 rounded-full object-cover" alt="" /></div>;
    $[8] = userImg;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== userNick) {
    t11 = <div className="flex flex-1 overflow-hidden"><span className="inline-flex max-w-[100px] overflow-hidden align-top"><span className="overflow-hidden truncate text-[15px] leading-[21px]">{userNick}</span></span></div>;
    $[10] = userNick;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== isLive || $[13] !== isRT) {
    t12 = isLive && <LiveBadge className="relative shrink-0" style={{
      fontSize: 28
    }} isRT={isRT} />;
    $[12] = isLive;
    $[13] = isRT;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== coords || $[16] !== isLive || $[17] !== onClick || $[18] !== title || $[19] !== userNick) {
    t13 = coords && isLive && typeof document !== "undefined" && createPortal(<div ref={popupAreaRef} className="fixed z-50" style={{
      top: coords.top,
      left: coords.left,
      width: POPUP_WIDTH + HOVER_BRIDGE_WIDTH
    }} onMouseLeave={event_1 => {
      if (isMovingInsideSharedHoverArea(event_1.relatedTarget)) {
        return;
      }
      setCoords(null);
    }}><button type="button" className="flex w-[211px] flex-col items-start gap-1 rounded-[10px] border border-borderBg14 bg-baseBg px-4 py-2 text-left shadow-[0_4px_8px_rgba(0,0,0,0.25)]" style={{
        marginLeft: HOVER_BRIDGE_WIDTH
      }} onClick={() => {
        onClick();
        setCoords(null);
      }}><div className="line-clamp-1 font-bold text-[#04a1d4] text-[14px] leading-[20px] tracking-[-0.5px]">{userNick}</div><div className="line-clamp-2 w-full overflow-hidden break-all text-[13px] text-baseFg leading-[19px] tracking-[-0.5px]">{title}</div></button></div>, document.body);
    $[15] = coords;
    $[16] = isLive;
    $[17] = onClick;
    $[18] = title;
    $[19] = userNick;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t13 || $[25] !== t7) {
    t14 = <li ref={itemRef} className="flex h-[50px] w-full items-center gap-6 rounded-[10px] px-[17px] text-[15px] tracking-[-0.5px] hover:cursor-pointer hover:bg-colorBg01" onClick={t7} onMouseEnter={t8} onMouseLeave={t9}>{t10}{t11}{t12}{t13}</li>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t7;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}
export default BJListItem;